import MList from "./MList.vue";
export { default as MListItem } from "./MListItem";
export default MList;
